// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__3x5w1","message":"CookieConsent_message__XX4X3","cookieLink":"CookieConsent_cookieLink__1eeMl","continueBtn":"CookieConsent_continueBtn__3Eg-b"};